/* eslint-disable max-len */
import { NthDayOfWeek } from '^/types/__BrandedDateTimeTypes';

import { WEEK_EN } from '../../Calendar.constants';
import type { CalendarMonthViewModel } from '../Month/Calendar.Month.viewmdel';

import { DayType } from './DayType';

export class CalendarDayViewModel extends DayType {
  constructor(
    public readonly monthViewModel: CalendarMonthViewModel,
    public readonly day: number,
    public readonly isLastDateOfMonth: boolean,
    public readonly isFirstDateOfMonth = day === 1,
    public readonly dayOfWeek = (monthViewModel.startWeekDay + day - 1) % 7 as NthDayOfWeek,
    public readonly isWeekDay = 0 < dayOfWeek && dayOfWeek < 6,
    public readonly dayNameInWeek = WEEK_EN[dayOfWeek],
  ) {
    super(
      monthViewModel.yearMonth,
      day,
      dayOfWeek,
    );
  }
}
